module.exports = __webpack_public_path__ + "img/special-red.e0540cb0.svg";